import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';

class OpportunitySecurityChecklistItem {
  constructor(item) {
    if (item == null) {
      this.OpportunitySecurityChecklistId = '';
      this.ApprovedLogoUsage = '';
      this.ApprovedNameUsage = '';
      this.AuthorizedClientBusinessRep = '';
      this.ClientAccountContactsData = 'according to the civil limitation period for a particular contract';
      this.ClientOperationalContactsData = 'according to the civil limitation period for a particular contract';
      this.ClientOperationalContactsExport = '';
      this.ContactEmail = '';
      this.ContactName = '';
      this.ContactPhone = '';
      this.DataFlowMap = [];
      this.DeliveredEvaluationDetails = 'indefinite in an anonymized format';
      this.DeliveredEvaluationDetailsExport = '';
      this.ErasureNotification = '';
      this.PublicInformationClassification = '';
      this.ConfidentialInformationClassification = '';
      this.InternalInformationClassification = '';
      this.RestrictedInformationClassification = '';
      this.OpportunityId = '';
      this.PrivacyBreachNotification = '';
      this.SecurityIncidentNotification = '';
      this.SubjectInquiryNotification = '';
      this.DataFlowMapFreeText = '';
      this.ClientId = '';
      this.DataFlowMapDisplay = '';
      this.AuthorizedClientBusinessRepNames = '';
      this.Comment = '';
      return;
    }
    this.OpportunitySecurityChecklistId = item.opportunitySecurityChecklistId;
    this.ApprovedLogoUsage = item.approvedLogoUsage;
    this.ApprovedNameUsage = item.approvedNameUsage;
    this.AuthorizedClientBusinessRep = item.authorizedClientBusinessRep;
    this.ClientAccountContactsData = item.clientAccountContactsData;
    this.ClientAccountContactsDataDisplay = isNaN(item.clientAccountContactsData)
      ? item.clientAccountContactsData
      : item.clientAccountContactsData + ' months';
    this.ClientOperationalContactsData = item.clientOperationalContactsData;
    this.ClientOperationalContactsDataDisplay = isNaN(item.clientOperationalContactsData)
      ? item.clientOperationalContactsData
      : item.clientOperationalContactsData + ' months';
    this.ClientOperationalContactsExport = item.clientOperationalContactsExport;
    this.ContactEmail = item.contactEmail;
    this.ContactName = item.contactName;
    this.ContactPhone = item.contactPhone;
    this.DataFlowMap = item.dataFlowMap;
    this.DeliveredEvaluationDetails = item.deliveredEvaluationDetails;
    this.DeliveredEvaluationDetailsDisplay = isNaN(item.deliveredEvaluationDetails)
      ? item.deliveredEvaluationDetails
      : item.deliveredEvaluationDetails + ' months';
    this.DeliveredEvaluationDetailsExport = item.deliveredEvaluationDetailsExport;
    this.ErasureNotification = item.erasureNotification;
    this.PublicInformationClassification = item.publicInformationClassification;
    this.ConfidentialInformationClassification = item.confidentialInformationClassification;
    this.InternalInformationClassification = item.internalInformationClassification;
    this.RestrictedInformationClassification = item.restrictedInformationClassification;
    this.OpportunityId = item.opportunityId;
    this.PrivacyBreachNotification = item.privacyBreachNotification;
    this.SecurityIncidentNotification = item.securityIncidentNotification;
    this.SubjectInquiryNotification = item.subjectInquiryNotification;
    this.DataFlowMapFreeText = item.dataFlowMapFreeText;
    this.ClientId = item.clientId;
    this.DataFlowMapDisplay = Array.isArray(item.dataFlowMap) ? item.dataFlowMap.join(', ') : '';
    this.AuthorizedClientBusinessRepNames = item.authorizedClientBusinessRepNames;
    this.Comment = item.comment;
  }

  static NameOfTheIdField() {
    return 'OpportunityId';
  }

  static nameOfTheItemDetailList = (item) => (
    <LongText
      text={`Opportunity #${item.OpportunityId}`}
      fitToBox
    />
  );

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static NavigationDesc = [];
  static DateFields = [];

  static BoolFields = ['ClientOperationalContactsExport', 'DeliveredEvaluationDetailsExport'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: '-', label: '' },
        { name: '-message-', label: 'Contact' },
        { name: 'ContactName', label: 'InfoSec and Privacy Contact Name', className: 'text-left' },
        { name: 'ContactEmail', label: 'InfoSec and Privacy Contact Email', className: 'text-left' },
        { name: 'ContactPhone', label: 'InfoSec and Privacy Contact Phone', className: 'text-left' },
        {
          name: 'AuthorizedClientBusinessRepNames',
          label: 'Authorized Client Business Representative',
          className: 'text-left',
        },
        {
          name: 'ApprovedLogoUsage',
          label: ' Client Logo usage approved?',
          className: 'text-left',
        },
        {
          name: 'ApprovedNameUsage',
          label: 'Clientname usage approved?',
          className: 'text-left',
        },
        { name: 'Comment', label: 'Comment', className: 'text-left', width: TabListTableCellWidthEnum.TwoLines },

        { name: '-', label: '' },
        { name: '-message-', label: 'SLA & Storage' },
        { name: 'SecurityIncidentNotification', label: 'Security Incident Notification', className: 'text-left' },
        { name: 'PrivacyBreachNotification', label: 'Privacy Breach Notification', className: 'text-left' },
        { name: 'SubjectInquiryNotification', label: 'Subject Inquiry Notification', className: 'text-left' },
        { name: 'ErasureNotification', label: 'Erasure Notification', className: 'text-left' },

        {
          name: 'DataFlowMapDisplay',
          label: 'Data Storage Location',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: 'DataFlowMapFreeText',
          label: 'Data Storage Location Description',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },

        { name: '-', label: '' },
        {
          name: '-message-',
          label: 'Data Management',
        },
        {
          name: 'ClientAccountContactsDataDisplay',
          label: 'Client Account Contacts Personal Data',
          className: 'text-left',
        },
        {
          name: 'ClientOperationalContactsDataDisplay',
          label: 'Client Operational Contacts Personal Data',
          className: 'text-left',
        },
        { name: 'DeliveredEvaluationDetailsDisplay', label: 'Delivered Evaluation Details', className: 'text-left' },

        {
          name: (item) => JsxHelper.YesNo(item.ClientOperationalContactsExport),
          label: 'Export Client operational contacts at termination?',
          className: 'text-left',
        },
        {
          name: (item) => JsxHelper.YesNo(item.DeliveredEvaluationDetailsExport),
          label: 'Export evaluation details at termination?',
          className: 'text-left',
        },
        {
          name: 'PublicInformationClassification',
          label: 'Public Information Classification',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: 'ConfidentialInformationClassification',
          label: 'Confidential Information Classification',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: 'InternalInformationClassification',
          label: 'Internal Information Classification',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: 'RestrictedInformationClassification',
          label: 'Restricted Information Classification',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'OpportunityId',
        orderById: 'OpportunityId',
        data: 'OpportunityId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
    ];
  }
}

export default OpportunitySecurityChecklistItem;
